import { RoundedPrimaryBtn, RoundedSecondaryBtn } from '@components/global';

interface RoundedButtonProps {
  btnVariant: 'primary' | 'secondary';
  displayText: string;
  onClickCallback: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const RoundedButton = ({
  btnVariant,
  displayText,
  onClickCallback,
}: RoundedButtonProps) => {
  return btnVariant === 'primary' ? (
    <RoundedPrimaryBtn
      data-testid="Button--RoundedPrimary"
      rank="primary"
      type="button"
      onClick={onClickCallback}
    >
      {displayText}
    </RoundedPrimaryBtn>
  ) : (
    <RoundedSecondaryBtn
      data-testid="Button--RoundedSecondary"
      rank="secondary"
      type="button"
      onClick={onClickCallback}
    >
      {displayText}
    </RoundedSecondaryBtn>
  );
};
